import { HTMLControl } from '../controls/html_control.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';

const kNoTrackLabel = `Associate with`;
const kHasTrackLabel = `Track is associated`;

/**
 * Pick track control.
 */
class PickTrackControl extends HTMLControl {
  initialize() {
    super.initialize();
    listenToEvent(
      this.pickButton,
      'click',
      () => (this.pickMode = !this.pickMode)
    );
  }

  get track() {
    return this.#track;
  }

  set track(v) {
    this.#track = v;
    if (v) {
      this.setAttribute('hastrack', 'true');
      this.textElement.textContent = kHasTrackLabel;
    } else {
      this.removeAttribute('hastrack');
      this.textElement.textContent = kNoTrackLabel;
    }
  }

  get pickMode() {
    return this.#pickMode;
  }

  set pickMode(v) {
    if (this.#pickMode == !!v) {
      return;
    }

    this.#pickMode = !!v;
    if (this.#pickMode) {
      this.pickButton.setAttribute('pressed', true);
    } else {
      this.pickButton.removeAttribute('pressed');
    }

    this.map.activePickControl = (this.#pickMode && this) || null;
  }

  pickTrack(track) {
    this.track = track;
    this.pickMode = false;
  }

  static markup = `
    <span class='text'>${kNoTrackLabel}</span>
    <img class='autocomplete-button pick-button'
         title='Pick a track'
         src='/images/pick.svg'>
  `;

  static selectors = {
    PickButton: '.pick-button',
    Text: '.text',
  };

  static get elements() {
    return {
      pickButton: this.selectors.PickButton,
      textElement: this.selectors.Text,
    };
  }

  #pickMode;
  #track;
}

window.customElements.define('pick-track-control', PickTrackControl);

export { PickTrackControl };
